import css from '@emotion/css';
import ScreenReaderOnly from '@embed/components/common/ScreenReaderOnly';
export const AccessibleIcon = ({ alt, src, height, width }) => {
    return (<span role="presentation" css={css `
        display: block;
        background: transparent url(${src}) no-repeat center center;
        background-size: cover;
        height: ${height};
        width: ${width};
      `}>
      <ScreenReaderOnly>{alt}</ScreenReaderOnly>
    </span>);
};
